/* eslint-disable */
import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface SRSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SRSearchBar: React.FC<SRSearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search by SR key, title, or area...',
}) => {
  return (
    <TextField
      data-testid="sr-search-bar"
      fullWidth
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
      sx={{
        backgroundColor: 'background.paper',
      }}
    />
  );
};
